import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PropertyTypeViewControllerDelegate, PropertyTypeViewController } from "../../Screen/PropertyType/PropertyTypeViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PropertyTypeViewModel } from '../../Screen/PropertyType/PropertyTypeViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PropertyTypeCoordinator implements IndexCoordinatorDelegate, PropertyTypeViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptipoimovel")
        return (<ProtectedRoute requiredPermissions={['dengue.tipo_imovel.*']} path="/:base/dengue/tipo-imovel" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.tipo_imovel.adicionar',
                    edit: 'dengue.tipo_imovel.editar',
                    delete: 'dengue.tipo_imovel.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Tipo de Imóvel"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PropertyTypeViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.tipo_imovel.adicionar', 'dengue.tipo_imovel.editar']} path="/:base/dengue/tipo-imovel/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PropertyTypeViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipoimovel") {
            navigation.history.push(`tipo-imovel/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geptipoimovel") {
            navigation.history.push(`tipo-imovel/cad/${idSelection}`);
            return;
        }
    }

}